const invoiceMenu: any = {
  order: 14,
  id: "invoices",
  title: "Fatture",
  translate: "MENU.INVOICES",
  type: "collapsible",
  capability: "show_menu_invoice_general",
  icon: "dollar-sign",
  children: [
    // fatture da generare
    {
      id: "invoices-to-generate",
      title: "Fatture da generare",
      translate: "MENU.INVOICES_TO_GENERATE",
      type: "item",
      url: "dashboard/invoice/to-generate",
      capability: "show_menu_invoice_to_create",
    },
    // fatture generate --> le fatture da mandare a e-solver
    {
      id: "invoices-generated",
      title: "Fatture da emettere",
      translate: "MENU.INVOICES_GENERATED",
      type: "item",
      url: "dashboard/invoice/generated",
      capability: "show_menu_invoice_generated",
    },
    // fatture inviate --> qui non si può fare nulla
    {
      id: "invoices-sended",
      title: "Fatture inviate",
      translate: "MENU.INVOICES_SENDED",
      type: "item",
      url: "dashboard/invoice/sended",
      capability: "show_menu_invoice_sended",
    },
    // fatture completate --> qui le fatture che e-solver ha accettato e completato, ci saranno quelle con errori e quelle andate a buon fine
    {
      id: "invoices-completed",
      title: "Fatture emesse",
      translate: "MENU.INVOICES_COMPLETED",
      type: "item",
      url: "dashboard/invoice/completed",
      capability: "show_menu_invoice_completed",
    },
    // fatture archiviate --> qui le fatture che sono state archiviate e tolte dalla lista di quelle da generare
    {
      id: "invoices-archived",
      title: "Fatture archiviate",
      translate: "MENU.INVOICES_ARCHIVED",
      type: "item",
      url: "dashboard/invoice/archived",
      capability: "show_menu_invoice_archived",
    },
    // note di credito
    // {
    //   id: "invoices-credit_note",
    //   title: "Note di credito",
    //   translate: "MENU.CREDIT_NOTE",
    //   type: "item",
    //   url: "dashboard/credit-note",
    //   capability: "show_menu_credit_note",
    // },
  ],
};
export default invoiceMenu;
